import _extends from '@babel/runtime/helpers/extends';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import classnames from 'classnames';
import React__default, { useState, useEffect } from 'react';
import useCanvasId from '../../utils/useCanvasId.js';

var _excluded = ["className", "data-testid", "indeterminate", "id", "value", "min", "max", "step", "onChange", "onUpdate", "withInput", "error", "disabled", "required"];
var InputRange = function InputRange(_ref) {
  var className = _ref.className,
    dataTestId = _ref['data-testid'];
    _ref.indeterminate;
    var id = _ref.id,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? null : _ref$value,
    _ref$min = _ref.min,
    min = _ref$min === void 0 ? 0 : _ref$min,
    _ref$max = _ref.max,
    max = _ref$max === void 0 ? 100 : _ref$max,
    _ref$step = _ref.step,
    step = _ref$step === void 0 ? 1 : _ref$step,
    onChange = _ref.onChange,
    onUpdate = _ref.onUpdate,
    _ref$withInput = _ref.withInput,
    withInput = _ref$withInput === void 0 ? false : _ref$withInput,
    error = _ref.error,
    disabled = _ref.disabled,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var finalClasses = classnames('C-Input--type-range', {
    isDisabled: disabled,
    isErrored: error
  }, className);
  var _useState = useState(value || min),
    _useState2 = _slicedToArray(_useState, 2),
    rangeValue = _useState2[0],
    setRangeValue = _useState2[1];
  var uuid = useCanvasId(id, 'Range');
  useEffect(function () {
    if (!value) {
      setRangeValue(min);
    } else {
      setRangeValue(value);
    }
  }, [value, min]);
  useEffect(function () {
    if (min >= max) {
      console.error("Hey Canvas User!\n     The range input requires the max value to be greater than the min value.\n     Your max: ".concat(max, "\n     Your min: ").concat(min));
    }
  }, [min, max]);
  var handleOnChange = function handleOnChange(event) {
    setRangeValue(event.target.value);
    onUpdate && onUpdate(otherProps.name || id, event.target.value);
    onChange && onChange(event);
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: finalClasses,
    "data-testid": dataTestId ? "".concat(dataTestId, "_container") : null
  }, !withInput && /*#__PURE__*/React__default.createElement("span", {
    className: "C-Input--type-range__value",
    "aria-hidden": "true"
  }, rangeValue), /*#__PURE__*/React__default.createElement("div", {
    className: "C-Input--type-range__slideContainer"
  }, withInput ? /*#__PURE__*/React__default.createElement("div", {
    className: "C-Input--type-range__bar withInput"
  }) : /*#__PURE__*/React__default.createElement("div", {
    className: "C-Input--type-range__bar"
  }), withInput ? /*#__PURE__*/React__default.createElement("div", {
    className: "C-Input--type-range__fill",
    id: "fill",
    style: {
      width: "calc((100% - 100px) * ((".concat(Math.min(Math.round((rangeValue - min) / step) * step + 1 * min, max), " - ").concat(min, ") / (").concat(max, " - ").concat(min, "))) ")
    }
  }) : /*#__PURE__*/React__default.createElement("div", {
    className: "C-Input--type-range__fill",
    id: "fill",
    style: {
      width: "calc(((".concat(Math.min(Math.round((rangeValue - min) / step) * step + 1 * min, max), " - ").concat(min, ") / (").concat(max, " - ").concat(min, ")) * 100%)")
    }
  }), /*#__PURE__*/React__default.createElement("input", _extends({
    className: "C-Input--type-range__slider",
    id: id ? id : uuid,
    type: "range",
    min: min,
    max: max,
    step: step,
    "data-testid": dataTestId,
    required: required,
    "aria-required": required ? 'true' : 'false',
    value: rangeValue,
    onChange: handleOnChange,
    disabled: disabled,
    "aria-valuemin": min,
    "aria-valuemax": max,
    "aria-valuenow": rangeValue
  }, otherProps)), withInput && /*#__PURE__*/React__default.createElement("input", {
    className: "C-Input C-Input--type-range__input ".concat(error ? 'isErrored' : ''),
    type: "number",
    min: min,
    max: max,
    step: step,
    required: required,
    value: rangeValue,
    onChange: handleOnChange,
    disabled: disabled,
    "aria-valuemin": min,
    "aria-valuemax": max,
    "aria-valuenow": rangeValue
  }))));
};
InputRange.displayName = 'Input.Range';

export { InputRange as default };
